import React, {useState} from "react";
import { Edit, CardActions, ShowButton, Toolbar, FileInput, FileField, TextInput } from 'react-admin';
import Form from "./Form";
import {Dialog, DialogActions, DialogContent, DialogContentText, Paper} from "@material-ui/core";
import required from "../helper/Required";
import LoadingComponent from "../component/LoadingComponent";
import SaveButtonAware from "../component/SaveButtonAware";
import ButtonMui from "@material-ui/core/Button";
import errorMessage from "../helper/ErrorMessage";

const DivisionEditTitle = ({ record }) => {
    return <span>Редагування аптеки {record ? `"${record.name}"` : ''}</span>;
};

const DivisionEditActions = ({ data }) => (
    <CardActions>
        <ShowButton record={data} label={"Переглянути"} />
    </CardActions>
);

const DivisionEdit = props => {
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [loading, setLoading] = useState(false);
    const [contractChanged, setContractChanged] = useState(false);

    const popupAlert = (message) => {
        setAlertOpen(true);
        setAlertText(message);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const handleSave = (values, redirect) => {
        setLoading(true);

        if (contractChanged && typeof values.sign !== 'undefined') {
            const reader = new FileReader();
            reader.onloadend = async event => {
                values.keyStore = event.target.result;
                let fileParts = values.sign.title.split('.');
                values.extension = fileParts[fileParts.length - 1];

                sendRequest(values);
            }

            reader.readAsDataURL(values.sign.rawFile);
        } else {
            sendRequest(values);
        }
    };

    const sendRequest = async values => {
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            },
            body: JSON.stringify(values)
        };

        try {
            const response = await fetch(
                process.env.REACT_APP_API_ENTRYPOINT + '/divisions/' + values.id,
                requestOptions
            );

            const data = await response.json();

            if (response.ok) {
                popupAlert('Запит успішно відправлений.');
            } else {
                errorMessage(data, popupAlert);
            }
            setLoading(false);
        } catch (error) {
            console.log(error);
            popupAlert('Помилка надсилання запиту');
            setLoading(false);
        }
    };

    const DivisionEditToolbar = props => (
        <Toolbar {...props}>
            <div className="toolbar-wrapper">
                {contractChanged ? <div>
                    <Paper elevation={3} className="public-offer legal-entities-tab-content" label="ЕЦП" multiline fullWidth={true}>
                        <FileInput className="digital-signature" formClassName="tab-content-item" source={'sign'} validate={required.validateRequired} label={"ЕЦП"} placeholder={"Вкажіть файл електронного цифрового підпису"} >
                            <FileField source="src" title="title" />
                        </FileInput>

                        {/*<AutocompleteInput source={"ca"} label={"Видавець цифрового підпису"} choices={caServices} validate={required.validateRequired} fullWidth={true} />*/}
                        <TextInput type={"password"} className="digital-signature-password tab-content-item" source={"password"} label={"Пароль ЕЦП"} validate={required.validateRequired} />
                    </Paper>
                </div> : null}
                <div className="toolbar-button-section">
                    {loading ? <LoadingComponent /> : <SaveButtonAware onSave={handleSave} label="Відправити запит" {...props} />}
                </div>

                <Dialog
                    open={alertOpen}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-content">
                            {alertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <ButtonMui onClick={handleAlertClose} color="primary">
                            OK
                        </ButtonMui>
                    </DialogActions>
                </Dialog>
            </div>
        </Toolbar>
    );

    return (
        <Edit
            title={<DivisionEditTitle />}
            actions={<DivisionEditActions />}
            undoable={false}
            {...props}
        >
            <Form
                toolbar={<DivisionEditToolbar {...props} />}
                checkContract={setContractChanged} {...props}
            />
        </Edit>
    );
};

export default DivisionEdit;
